const accentGlow = {
  violet: "hover:shadow-[0_0_0_1px_rgba(140,124,240,0.25),0_20px_60px_-20px_rgba(140,124,240,0.35)]",
  magenta: "hover:shadow-[0_0_0_1px_rgba(240,73,140,0.25),0_20px_60px_-20px_rgba(240,73,140,0.35)]",
  teal: "hover:shadow-[0_0_0_1px_rgba(69,217,192,0.25),0_20px_60px_-20px_rgba(69,217,192,0.35)]",
  none: ""
};
const GlassCard = ({ children, className = "", noPadding = false, accent = "violet" }) => {
  return (
    <div
      className={[
        "relative w-full h-full rounded-2xl",
        "bg-white/80 dark:bg-white/[0.035] backdrop-blur-xl",
        "border border-black/[0.06] dark:border-white/[0.08]",
        "shadow-[0_1px_0_rgba(255,255,255,0.6)_inset,0_20px_44px_-28px_rgba(31,41,74,0.16)] dark:shadow-none",
        "transition-all duration-300 ease-out",
        "hover:-translate-y-[2px] hover:bg-white dark:hover:bg-white/[0.05]",
        accentGlow[accent],
        noPadding ? "" : "p-4 md:p-5",
        className
      ].join(" ")}
    >
      {children}
    </div>
  );
};
var GlassCard_default = GlassCard;
export { GlassCard_default as default };